__turbopack_context__.v({
  "badgeHidden": "CPhotoGallery-module__j0otHG__badgeHidden",
  "badgePublic": "CPhotoGallery-module__j0otHG__badgePublic",
  "btnDanger": "CPhotoGallery-module__j0otHG__btnDanger",
  "btnLink": "CPhotoGallery-module__j0otHG__btnLink",
  "btnPrimary": "CPhotoGallery-module__j0otHG__btnPrimary",
  "btnSecondary": "CPhotoGallery-module__j0otHG__btnSecondary",
  "card": "CPhotoGallery-module__j0otHG__card",
  "cardActions": "CPhotoGallery-module__j0otHG__cardActions",
  "cardBody": "CPhotoGallery-module__j0otHG__cardBody",
  "cardCount": "CPhotoGallery-module__j0otHG__cardCount",
  "cardCover": "CPhotoGallery-module__j0otHG__cardCover",
  "cardCoverEmpty": "CPhotoGallery-module__j0otHG__cardCoverEmpty",
  "cardName": "CPhotoGallery-module__j0otHG__cardName",
  "cardSkeleton": "CPhotoGallery-module__j0otHG__cardSkeleton",
  "empty": "CPhotoGallery-module__j0otHG__empty",
  "form": "CPhotoGallery-module__j0otHG__form",
  "formActions": "CPhotoGallery-module__j0otHG__formActions",
  "formTitle": "CPhotoGallery-module__j0otHG__formTitle",
  "galleryGrid": "CPhotoGallery-module__j0otHG__galleryGrid",
  "imageActions": "CPhotoGallery-module__j0otHG__imageActions",
  "imageGrid": "CPhotoGallery-module__j0otHG__imageGrid",
  "imageItem": "CPhotoGallery-module__j0otHG__imageItem",
  "imageItemMain": "CPhotoGallery-module__j0otHG__imageItemMain",
  "imagesToolbar": "CPhotoGallery-module__j0otHG__imagesToolbar",
  "listToolbar": "CPhotoGallery-module__j0otHG__listToolbar",
  "mainBadge": "CPhotoGallery-module__j0otHG__mainBadge",
  "pagBtn": "CPhotoGallery-module__j0otHG__pagBtn",
  "pagInfo": "CPhotoGallery-module__j0otHG__pagInfo",
  "pagination": "CPhotoGallery-module__j0otHG__pagination",
  "root": "CPhotoGallery-module__j0otHG__root",
});
